import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';
import Cookies from 'universal-cookie';


const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login

class SidebarCoordinacionAcad extends Component {
    componentDidMount() {
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Coordinación Académica</p>
                        </div>

                        <Link to="/coordinacionacad" className="nav-link-custom">
                            <i className="fas fa-university me-2"></i>
                            Página Principal A
                        </Link>

                        {/* Matrículas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculas"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i> Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseMatriculas">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Coordinacionacad/MatriculasPeriodC" className="nav-sub-link">
                                        Matrículas Coordinación
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Calificaciones */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseCalif"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i> Calificaciones
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseCalif">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Coordinacionacad/CalificacionesEstud" className="nav-sub-link">
                                        Calificaciones
                                    </Link>
                                    <Link to="/Coordinacionacad/CalificacionesDetall" className="nav-sub-link">
                                        Calificaciones Detallada
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Asignaturas */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseDocentes"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-book me-2"></i> Asignaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseDocentes">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Coordinacionacad/AsignaturasEstCarreraCicloAdm" className="nav-sub-link">
                                        Asignaturas Carrera Ciclo
                                    </Link>
                                    <Link to="/Coordinacionacad/AsignaturasDocentePeriodoAdm" className="nav-sub-link">
                                        Asignaturas Docente Periodo
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Perfil */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfil"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i> Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfil">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Coordinacionacad/VerPerfilCoordAcad" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Evaluaciones Docentes */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseEvalDocentesVicerAcad"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-check-circle me-2"></i>
                                    Evaluaciones Docentes
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseEvalDocentesVicerAcad">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/Coordinacionacad/HeteroEvalAsignaturasDocentePeriodo"
                                        className="nav-sub-link"
                                    >
                                        Heteroevaluación
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(SidebarCoordinacionAcad);